// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0a33e668","513":"5fb27bcf","703":"30092284","787":"627756db"}[chunkId] + ".chunk.js";
};